export const traditionalChineseNotificationText = {
  "ARTIFACT_EXPORT": "成品匯出",
  "AUTHENTICATION": "身分驗證",
  "API key settings deleted.": "API 金鑰設定已刪除。",
  "All datasets and tables in the current organization's Trash will be permanently deleted. This action cannot be undone.":
    "目前組織垃圾桶中的所有資料集與資料表將被永久刪除，且無法復原。",
  "An error occurred": "發生錯誤。",
  "Are you sure you want to delete this task?": "確定要刪除此任務嗎？",
  "Are you sure you want to Delete this folder?": "確定要刪除此資料夾嗎？",
  "Are you sure you want to close this project?": "確定要關閉此專案嗎？",
  "Clear Data": "清除資料",
  "Clone dataset success": "資料集複製成功。",
  "Close Project": "關閉專案",
  "Confidence threshold is Invalid. Please choose a number between 0.0 to 1.0":
    "信心分數閾值無效，請輸入 0.0 至 1.0 之間的數值。",
  "Component:": "元件：",
  "Container Logs:": "容器日誌：",
  "DAG path not available on this card.": "此模型卡沒有可用的 DAG 路徑。",
  "Data cannot be recovered after deletion, please proceed with caution.":
    "資料刪除後無法復原，請謹慎操作。",
  "DATA_PREPARATION": "資料準備",
  "Dataset that represents a folder/table can not be deleted here, please delete them in folder/table page instead.":
    "代表資料夾或資料表的資料集無法在此刪除，請前往對應頁面操作。",
  "Datasets have been merged successfully.": "資料集合併成功。",
  "Delete API key settings?": "刪除 API 金鑰設定？",
  "Delete Dataset": "刪除資料集",
  "Delete Folder": "刪除資料夾",
  "Delete Redundant": "刪除重複資料",
  "Done": "完成",
  "ETL labels in dataset to table success": "資料集標籤 ETL 至資料表成功。",
  "Email is required": "請輸入電子郵件。",
  "Empty dataset should not be upload to CVAT.": "空白資料集無法上傳至 CVAT。",
  "Empty dataset should not be upload to Label Studio.":
    "空白資料集無法上傳至 Label Studio。",
  "Empty Trash": "清空垃圾桶",
  "Error Message:": "錯誤訊息：",
  "Error Code:": "錯誤代碼：",
  "ERROR_REPORTING": "錯誤報告",
  "EVALUATION": "評估",
  "Evaluation task has been submitted!": "評估任務已提交。",
  "Evaluation Results": "評估結果",
  "Failed": "失敗",
  "Failed Components:": "失敗的元件：",
  "Failed Stage:": "失敗階段：",
  "Failed to check tensorboard status": "無法檢查 TensorBoard 狀態。",
  "Failed to delete group": "刪除群組失敗。",
  "Failed to fetch data": "載入資料失敗。",
  "Failed to fetch error information": "取得錯誤資訊失敗。",
  "Failed to fetch models": "載入模型失敗。",
  "Failed to get tensorboard run ID": "無法取得 TensorBoard 執行 ID。",
  "Failed to load IP Evaluation defaults from backend":
    "無法從後端載入 IP 評估預設值。",
  "Failed to load NEF model information from backend":
    "無法從後端載入 NEF 模型資訊。",
  "Failed to load datasets": "載入資料集失敗。",
  "Failed to empty Trash.": "清空垃圾桶失敗。",
  "Failed to read evaluation result": "讀取評估結果失敗。",
  "Failed to save model cards to server.": "儲存模型卡至伺服器失敗。",
  "For report, only JSON files are allowed.": "報告僅允許使用 JSON 檔案。",
  "IP Evaluation task has been submitted!": "IP 評估任務已提交。",
  "Image quality should between 1 and 100.": "圖片品質必須介於 1 到 100。",
  "Iou threshold is Invalid. Please choose a number between 0.0 to 1.0":
    "IoU 閾值無效，請輸入 0.0 至 1.0 之間的數值。",
  "Load data success": "資料載入成功。",
  "Loading error information...": "正在載入錯誤資訊...",
  "Login failed. Please check your credentials.": "登入失敗，請檢查帳號與密碼。",
  "Login required to restore from MinIO.": "從 MinIO 復原前請先登入。",
  "Matched model is missing cls_mapping.": "符合的模型缺少 cls_mapping。",
  "Model deleted successfully!": "模型已成功刪除。",
  "Model, image, and search integrations for this organization will stop working until new credentials are saved.":
    "在儲存新的憑證前，此組織的語言模型、圖片與搜尋整合將停止運作。",
  "Message:": "訊息：",
  "Models removed from group successfully!": "模型已成功移出群組。",
  "Move datasets to/from group successfully.": "資料集群組調整成功。",
  "NEF file download succeeded!": "NEF 檔案下載成功。",
  "NEF_GENERATION": "NEF 產生",
  "NEF generation task has been submitted!": "NEF 產生任務已提交。",
  "Network Error": "網路錯誤，請檢查連線後再試。",
  "No completed model found. Please check if the model_name is correct.":
    "找不到已完成的模型，請確認 model_name 是否正確。",
  "No detailed error information available. Please check Kubeflow UI.":
    "沒有可用的詳細錯誤資訊，請查看 Kubeflow 介面。",
  "No folder name.": "請輸入資料夾名稱。",
  "No Data": "沒有資料。",
  "No parameters were modified.": "沒有修改任何參數。",
  "No run_id available for this model": "此模型沒有可用的執行 ID。",
  "No tensorboard run ID received from backend":
    "後端未傳回 TensorBoard 執行 ID。",
  "Not logged in or token missing; please sign in again.":
    "尚未登入或登入憑證遺失，請重新登入。",
  "Or if you want to clear data only but keep the folder?":
    "或者只清除資料並保留資料夾？",
  "Password is required": "請輸入密碼。",
  "Passwords do not match": "兩次輸入的密碼不一致。",
  "Pipeline Error Details": "管線錯誤詳細資訊",
  "PIPELINE": "管線",
  "MODEL_OPTIMIZATION": "模型最佳化",
  "Root Cause:": "根本原因：",
  "SUBMISSION": "提交",
  "TRAINING": "訓練",
  "VALIDATION": "驗證",
  "Please import to Label Studio or CVAT and annotate.":
    "請先匯入 Label Studio 或 CVAT 並完成標註。",
  "Please Sign in": "請先登入。",
  "Please add at least one label.": "請至少新增一個標籤。",
  "Please allow pop-ups to open FiftyOne.": "請允許彈出式視窗以開啟 FiftyOne。",
  "Please choose DAG and sub DAG.": "請選擇 DAG 與子 DAG。",
  "Please choose a model.": "請選擇模型。",
  "Please enter a YouTube Link.": "請輸入 YouTube 連結。",
  "Please enter a prompt": "請輸入提示詞。",
  "Please input a dataset name.": "請輸入資料集名稱。",
  "Please input a folder name.": "請輸入資料夾名稱。",
  "Please input a group name.": "請輸入群組名稱。",
  "Please input a table path.": "請輸入資料表路徑。",
  "Please input a target dataset name.": "請輸入目標資料集名稱。",
  "Please input an email.": "請輸入電子郵件。",
  "Please input project name": "請輸入專案名稱。",
  "Please input start and end indexs.": "請輸入起始與結束索引。",
  "Please join an organization before creating a CVAT project.":
    "建立 CVAT 專案前請先加入組織。",
  "Please select a DAG first.": "請先選擇 DAG。",
  "Please select a document.": "請選擇文件。",
  "Please select a folder.": "請選擇資料夾。",
  "Please select a project.": "請選擇專案。",
  "Please select an organization.": "請選擇組織。",
  "Please select at least one source image": "請至少選擇一張來源圖片。",
  "Please select a source image": "請選擇來源圖片。",
  "Please select dataset.": "請選擇資料集。",
  "Please select models.": "請選擇模型。",
  "Please selected label and input new label name you want to rename.":
    "請選擇標籤並輸入新的標籤名稱。",
  "Please selected label you want to delete.": "請選擇要刪除的標籤。",
  "Please type your path.": "請輸入路徑。",
  "Please upload a file.": "請上傳檔案。",
  "Please upload the audio file.": "請上傳音訊檔案。",
  "Priority must be between 1 and 10.": "優先順序必須介於 1 到 10。",
  "Provide an evaluation table or a MinIO ZIP.":
    "請提供評估資料表或 MinIO ZIP 檔案。",
  "Save LLM annotation successfully.": "LLM 標註儲存成功。",
  "Quit organization?": "退出組織？",
  "Remove member?": "移除成員？",
  "Remove organizer role?": "移除組織者權限？",
  "Select at least one dataset": "請至少選擇一個資料集。",
  "Select target organization": "請選擇目標組織。",
  "Signup failed. Please try again.": "註冊失敗，請稍後再試。",
  "Start index can not be greater than end index.":
    "起始索引不可大於結束索引。",
  "TensorBoard creation failed": "建立 TensorBoard 失敗。",
  "The Trash has been successfully cleaned up.": "垃圾桶已成功清空。",
  "The dataset will be transferred to the Trash, please check whether to execute the task.":
    "資料集將移至垃圾桶，請確認是否執行此操作。",
  "The deletion of all datasets was completed successfully.":
    "所有資料集已成功刪除。",
  "The selected datasets have been moved to Trash.":
    "所選資料集已移至垃圾桶。",
  "The selected datasets have been successfully deleted.":
    "所選資料集已成功刪除。",
  "Uniqueness threshold is Invalid. Please choose a number between 0.0 to 1.0":
    "唯一性閾值無效，請輸入 0.0 至 1.0 之間的數值。",
  "Unknown Error": "未知錯誤。",
  "Unknown error": "未知錯誤。",
  "Unknown error occurred": "發生未知錯誤。",
  "Unsupported media type for upload.": "不支援此上傳媒體類型。",
  "Update CVAT Jobs' status success.": "CVAT 工作狀態更新成功。",
  "Upload selected datasets to CVAT success": "所選資料集已成功上傳至 CVAT。",
  "Username is required": "請輸入使用者名稱。",
  "You can now click the evaluation link in the model card to view the results.":
    "現在可以點擊模型卡上的評估連結查看結果。",
  "document not selected.": "尚未選擇文件。",
  "keyword: chapter / title not selected.": "尚未選擇關鍵字：章節或標題。",
};

export const traditionalChineseNotificationPatterns = [
  [/^At most (\d+) source image\(s\) for this model$/, "此模型最多可選擇 $1 張來源圖片。"],
  [/^Trash was partially cleared\. (\d+) item\(s\) could not be deleted\.$/, "垃圾桶已部分清空，$1 個項目無法刪除。"],
  [/^Dataset "(.+)" already exists\.\nAppend newly generated images to this dataset\?\n\nOK: Keep existing data and append\nCancel: Go back and enter a different name$/, "資料集「$1」已存在。\n是否將新產生的圖片附加至此資料集？\n\n確定：保留現有資料並附加\n取消：返回並輸入其他名稱"],
  [/^Dataset "(.+)" has been moved to Trash\.$/, "資料集「$1」已移至垃圾桶。"],
  [/^Dataset "(.+)" has been deleted successfully\.$/, "資料集「$1」已成功刪除。"],
  [/^Delete dataset '(.+)' success$/, "資料集「$1」刪除成功。"],
  [/^Delete group ['"](.+)['"] success\.?$/, "群組「$1」刪除成功。"],
  [/^Delete group "(.+)"\? Models will be ungrouped\.$/, "確定刪除群組「$1」嗎？模型將移出此群組。"],
  [/^Group "(.+)" deleted successfully!$/, "群組「$1」已成功刪除。"],
  [/^Restored '(.+)' from MinIO\.$/, "已從 MinIO 復原「$1」。"],
  [/^Folder "(.+)" has been created successfully\.$/, "資料夾「$1」已成功建立。"],
  [/^File '(.+)' upload success\.$/, "檔案「$1」上傳成功。"],
  [/^Table "(.+)" has been loaded successfully\.$/, "資料表「$1」載入成功。"],
  [/^Save config on dataset '(.+)' success$/, "資料集「$1」的設定儲存成功。"],
  [/^Import folder '(.+)' success, you can go to label studio webiste to config$/, "資料夾「$1」匯入成功，請前往 Label Studio 網站設定。"],
  [/^Project (.+) Create successed$/, "專案「$1」建立成功。"],
  [/^Export project '(.+)' success, the export dir is '(.+)'$/, "專案「$1」匯出成功，匯出目錄為「$2」。"],
  [/^ETL label-studio project '(.+)' to table success$/, "Label Studio 專案「$1」ETL 至資料表成功。"],
  [/^Invite '(.+)' to '(.+)' success\.$/, "已成功邀請「$1」加入「$2」。"],
  [/^Remove '(.+)' from '(.+)' success\.$/, "已成功將「$1」移出「$2」。"],
  [/^Add '(.+)' as organizer in '(.+)' success\.$/, "已成功將「$1」設為「$2」的組織者。"],
  [/^Delete '(.+)' as organizer from '(.+)' success\.$/, "已取消「$1」在「$2」的組織者權限。"],
  [/^Set priority for '(.+)' to (.+) success\.$/, "已成功將「$1」的優先順序設為 $2。"],
  [/^You will immediately lose access to datasets and services owned by (.+)\. An organizer must invite you again to restore access\.$/, "您將立即失去「$1」所擁有的資料集與服務存取權；必須由組織者再次邀請才能恢復存取。"],
  [/^(.+) will remain a member but will no longer be able to manage this organization\.$/, "「$1」仍會保留成員身分，但無法再管理此組織。"],
  [/^(.+) will immediately lose access to (.+)\.$/, "「$1」將立即失去「$2」的存取權。"],
  [/^Reset (.+) to code defaults\?$/, "確定要將 $1 重設為程式碼預設值嗎？"],
  [/^Move (\d+) dataset\(s\) to organization "(.+)"\?\nThis moves disk paths and updates FiftyOne\. CVAT\/Label Studio tasks may need re-import\.$/, "確定要將 $1 個資料集移至組織「$2」嗎？\n此操作會移動磁碟路徑並更新 FiftyOne；CVAT／Label Studio 任務可能需要重新匯入。"],
  [/^CVAT project '(.+)' created$/, "CVAT 專案「$1」已建立。"],
  [/^Upload dataset '(.+)' to (CVAT|Label Studio) success$/, "資料集「$1」已成功上傳至 $2。"],
  [/^SDK downLoad label on dataset '(.+)' success$/, "資料集「$1」的 SDK 標籤下載成功。"],
  [/^Delete task on CVAT for dataset '(.+)' success$/, "資料集「$1」的 CVAT 任務刪除成功。"],
  [/^Delete project on Label Studio for dataset '(.+)' success$/, "資料集「$1」的 Label Studio 專案刪除成功。"],
  [/^Generated (\d+) image\(s\) in dataset "(.+)"$/, "已在資料集「$2」中產生 $1 張圖片。"],
  [/^Successfully generated (\d+) image\(s\) and added to dataset '(.+)'$/, "已成功產生 $1 張圖片並加入資料集「$2」。"],
  [/^There is no sample in dataset '(.+)'$/, "資料集「$1」中沒有樣本。"],
  [/^There is no label in dataset '(.+)'$/, "資料集「$1」中沒有標籤。"],
  [/^Compute uniqueness on dataset '(.+)' success$/, "資料集「$1」的唯一性計算成功。"],
  [/^Sample rate is Invalid\. Please choose a number between 2 to (.+)$/, "取樣率無效，請輸入 2 至 $1 之間的數值。"],
  [/^Down-sampling on dataset '(.+)' success$/, "資料集「$1」降採樣成功。"],
  [/^Please choose number between 1 to 100 as split number\. Your input is (.+)\.$/, "請輸入 1 至 100 之間的分割數值，目前輸入為 $1。"],
  [/^Please both input evaluated field and target field in dataset '(.+)'$/, "請輸入資料集「$1」的評估欄位與目標欄位。"],
  [/^Compute error rate on dataset '(.+)' success$/, "資料集「$1」的錯誤率計算成功。"],
  [/^Delete samples by error rate on dataset '(.+)' success$/, "已依錯誤率刪除資料集「$1」的樣本。"],
  [/^Cut dataset by error rate on dataset '(.+)' success$/, "已依錯誤率切分資料集「$1」。"],
  [/^Batch ETL failed: (.+)$/s, "批次 ETL 失敗：$1"],
  [/^ETL labels in dataset '(.+)' to table success$/, "資料集「$1」的標籤 ETL 至資料表成功。"],
  [/^Download dataset '(.+)' success$/, "資料集「$1」下載成功。"],
  [/^Load label on dataset '(.+)' success$/, "資料集「$1」的標籤載入成功。"],
  [/^Export dataset '(.+)' success$/, "資料集「$1」匯出成功。"],
  [/^Please selected field of dataset '(.+)'$/, "請選擇資料集「$1」的欄位。"],
  [/^Please selected field for dataset '(.+)'$/, "請選擇資料集「$1」的欄位。"],
  [/^Please selected field and input new field name for dataset '(.+)'$/, "請選擇資料集「$1」的欄位並輸入新欄位名稱。"],
  [/^Edit field name on dataset '(.+)' success$/, "資料集「$1」的欄位名稱修改成功。"],
  [/^Delete field on dataset '(.+)' success$/, "資料集「$1」的欄位刪除成功。"],
  [/^Merge all fields by label types on '(.+)' success$/, "資料集「$1」已依標籤類型合併所有欄位。"],
  [/^Remap label class on dataset '(.+)' success$/, "資料集「$1」的標籤類別重新對應成功。"],
  [/^Delete label class on dataset '(.+)' success$/, "資料集「$1」的標籤類別刪除成功。"],
  [/^Delete bad label on dataset '(.+)' success$/, "資料集「$1」的不良標籤刪除成功。"],
  [/^Merge label on dataset '(.+)' success$/, "資料集「$1」的標籤合併成功。"],
  [/^Download folder '(.+)' success$/, "資料夾「$1」下載成功。"],
  [/^Load model in datasets '(.+)' success$/, "資料集「$1」的模型載入成功。"],
  [/^Are you sure you want to delete the model "(.+)"\?$/, "確定要刪除模型「$1」嗎？"],
  [/^Are you sure you want to delete (\d+) selected model\(s\)\?$/, "確定要刪除所選的 $1 個模型嗎？"],
  [/^Successfully deleted (\d+) model\(s\)!$/, "已成功刪除 $1 個模型。"],
  [/^Models moved to group "(.+)" successfully!$/, "模型已成功移至群組「$1」。"],
  [/^Started "(.+)" training pipeline\.$/, "已啟動「$1」訓練管線。"],
  [/^Duplicate audio classes after normalization: (.+)$/, "音訊類別正規化後重複：$1"],
  [/^Audio training requires at least one class\.$/, "音訊訓練至少需要一個類別。"],
  [/^Advanced parameters saved successfully! Modified: (.+)$/, "進階參數儲存成功；已修改：$1"],
  [/^Error: (.+)$/s, "錯誤：$1"],
  [/^Delete failed: (.+)$/s, "刪除失敗：$1"],
  [/^Save failed: (.+)$/s, "儲存失敗：$1"],
  [/^Evaluation submission failed: (.+)$/s, "評估提交失敗：$1"],
  [/^IP Evaluation failed: (.+)$/s, "IP 評估失敗：$1"],
  [/^NEF generation failed: (.+)$/s, "NEF 產生失敗：$1"],
];
